export type ExpandWidgetInput =
  | string
  | Ri2StarterBootstrapPayload
  | null
  | undefined

const isStarterBootstrapPayload = (
  value: ExpandWidgetInput,
): value is Ri2StarterBootstrapPayload =>
  !!value &&
  typeof value === "object" &&
  typeof value.starterMessage === "string"

export const normalizeStarterBootstrapPayload = (
  value: ExpandWidgetInput,
): Ri2StarterBootstrapPayload | null => {
  if (!value) {
    return null
  }

  if (typeof value === "string") {
    const starterMessage = value.trim()
    return starterMessage ? {starterMessage} : null
  }

  if (!isStarterBootstrapPayload(value)) {
    return null
  }

  const starterMessage = value.starterMessage.trim()
  if (!starterMessage) {
    return null
  }

  return {
    ...value,
    starterMessage,
  }
}

export const getInitialStarterBootstrapPayload =
  (): Ri2StarterBootstrapPayload | null =>
    normalizeStarterBootstrapPayload(
      window.ri2?.initialStarterPayload ?? window.ri2?.initialMessage,
    )
